import { render, staticRenderFns } from "./SkeletonBlock.vue?vue&type=template&id=63a72150&scoped=true&"
import script from "./SkeletonBlock.vue?vue&type=script&lang=js&"
export * from "./SkeletonBlock.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonBlock.vue?vue&type=style&index=0&id=63a72150&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a72150",
  null
  
)

export default component.exports